import React, { useState, useRef } from 'react';
import './App.css';

function App() {
    const [url, setUrl] = useState('');
    const [proxyUrl, setProxyUrl] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const iframeRef = useRef(null);

    // Backend URL - reads from environment variable or defaults to localhost for development
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 
        (typeof window !== 'undefined' && window.location.hostname === 'localhost' 
            ? 'http://localhost:8080'
            : 'https://your-backend-domain.com');

    function formatUrl(input) {
        // If it looks like a URL, use it
        try {
            return new URL(input).toString();
        } catch (e) {}

        // Try adding http://
        try {
            const withHttp = new URL('http://' + input);
            if (withHttp.hostname.includes('.')) {
                return withHttp.toString();
            }
        } catch (e) {}

        // Otherwise treat as search
        return 'https://www.google.com/search?q=' + encodeURIComponent(input);
    }

    function handleSubmit(e) {
        e.preventDefault();
        setError('');
        setLoading(true);

        if (!url.trim()) {
            setError('Please enter a URL');
            setLoading(false);
            return;
        }

        const finalUrl = formatUrl(url);
        // Point iframe to backend which handles the proxy
        setProxyUrl(BACKEND_URL + '/?url=' + encodeURIComponent(finalUrl));
        setLoading(false);
    }

    function handleDirectProxy() {
        // Open backend directly in new tab for full proxy experience
        if (!url.trim()) {
            setError('Please enter a URL');
            return;
        }
        window.open(BACKEND_URL, '_blank');
    }

    return (
        <div className="app">
            <h1>Clema</h1>
            <p>Simple web proxy</p>
            
            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                    placeholder="Enter URL or search..."
                />
                <button type="submit">Go</button>
            </form>

            <button onClick={handleDirectProxy} className="alt-btn">
                Open Proxy Interface
            </button>

            {error && <p className="error">{error}</p>}
            {loading && <p>Loading...</p>}

            {proxyUrl && (
                <div className="frame-container">
                    <p>Note: For best results, use the "Open Proxy Interface" button above.</p>
                    <iframe
                        ref={iframeRef}
                        src={proxyUrl}
                        title="Proxied Content"
                    />
                </div>
            )}
        </div>
    );
}

export default App;
